// Centralized API base URL for backend requests
import API_BASE from "../utils/apiBase";

const envBase = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE;

export const API_BASE_URL =
  envBase
    ? (envBase.endsWith('/api') ? envBase : `${envBase.replace(/\/+$/, '')}/api`)
    : (process.env.NODE_ENV === "production"
        ? "https://whitesmoke-tiger-919343.hostingersite.com/backend/api"
        : (API_BASE ? `${API_BASE}/api` : "http://localhost:8000/api"));

export function getProjectsUrl(category, page) {
  const params = new URLSearchParams({ category, page });
  return `${API_BASE_URL}/projects.php?${params}`;
}

// Add more API endpoints as needed
